import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { invoiceInput, invoiceInformation, collection } from 'src/api';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import * as aec_secret from 'src/utils/crypto';
class ModulesAction extends ActionBasic<ModulesState> {
    getGroupData = async (fields: any) => {
        const invoiceRes = await invoiceInput.invoice(this, fields);
        let rebornlist = invoiceRes.res;

        if (invoiceRes.er) {
            return null;
        }
        let uniqueArray = [];
        rebornlist.items = rebornlist.items.map((item, index) => {
            let appendData = { ...item };
            if (item.recordType === 2) {
                if (item.invoiceEntryList.length > 0) {
                    for(let i=0;i<item.invoiceEntryList.length;i++){
                        appendData.invoiceEntryList[i].index=appendData.invoiceEntryList[i].invoiceEntryId;
                        appendData.invoiceEntryList[i].pId=appendData.invoiceEntryList[i].invoiceGroupId;
                    }
                    appendData.children = appendData.invoiceEntryList;
                }
                appendData = {
                    ...appendData,
                    id: item.invoiceGroupId,
                    index: item.invoiceGroupId,
                    pId: null,
                    groupNumber: item.invoiceGroupResume.groupNumber,
                    invoiceCount: item.invoiceGroupResume.invoiceCount,
                    loggedCount: item.invoiceGroupResume.loggedCount,
                    shouldCount:item.invoiceGroupResume.shouldCount,
                    createType: item.invoiceGroupResume.createType,
                    matchState: item.invoiceGroupResume.matchState,
                };
            } else if (item.recordType === 1) {
                appendData = {
                    ...appendData,
                    id: item.invoiceEntryId,
                    index: item.invoiceEntryId,
                    pId: item.invoiceGroupId,
                };
            }
            return appendData;
        });
        //uniqueArray = Array.from(new Set(uniqueArray));
        // if (uniqueArray.length === 0) {
        //     return rebornlist;
        // }
        // let groupList: any = { groupIdList: uniqueArray };
        // const groupRes = await invoiceInput.group(this, groupList);
        // if (!groupRes.er) {
        //     let reborngrouplist = [];
        //     reborngrouplist = rebornlist.items.map((item) => {
        //         if (item.recordType === 2) {
        //             for (let i = 0; i < groupRes.res.length; i++) {
        //                 if (item.invoiceGroupId === groupRes.res[i].groupId) {
        //                     return {
        //                         ...item,
        //                         groupNumber: groupRes.res[i].groupNumber,
        //                         invoiceCount: groupRes.res[i].invoiceCount,
        //                         loggedCount: groupRes.res[i].loggedCount,
        //                         matchCount: groupRes.res[i].matchCount,
        //                         waitCount: groupRes.res[i].shouldCount,
        //                         createType: groupRes.res[i].createType,
        //                         matchState: groupRes.res[i].matchState,
        //                     };
        //                 }
        //             }
        //             return { ...item };
        //         } else {
        //             return { ...item };
        //         }
        //     });
        //     rebornlist.items = reborngrouplist;
        // }
        return rebornlist;
    }
    clearFields = () => {
        this.modulesState.fields = null;
        this.setModulesState(this.modulesState);
    }
    handleFormChange = (changedFields) => {
        this.modulesState.fields = { ...changedFields };
        this.setModulesState(this.modulesState);
    }
    onChange = (selectedRowKeys, selectedRows) => {
        this.modulesState.selectedRows = selectedRows;
        this.modulesState.selectedRowKeys = selectedRowKeys;
        this.setModulesState(this.modulesState);
    }
    refreshInvoice = () => {
        console.log(2);
    }

    /** dutao's */
    public additionalList = async () => {
        const res = await invoiceInformation.additionalList(this);
        this.modulesState.additionalList = res.res;
        this.setModulesState(this.modulesState);
    }

    public additionalListSingle = async (options: any) => {
        const res = await invoiceInformation.additionalListSingle(this, options);
        this.modulesState.additionalList = res.res;
        this.setModulesState(this.modulesState);
    }

    public additionalSave = async (options: any) => {
        const res = await invoiceInformation.additionalSave(this, options);
        if (!res.er) {
            MyStore.instance.dispatch(reducers.aside.ActionTypes.hide, null);
        }
    }
    //收票邮箱设置
    public getEmailList = async (page?: number) => {
        this.modulesState.emailList = [];
        this.setModulesState();
        const { pageSize, pageNum } = this.modulesState.emailPageMeta;
        const response = await collection.emailList(this, { pageSize, pageNum: page ? page : pageNum });
        const res = response.res as any;
        if (res) {
            this.modulesState.emailList = res.items;
            this.modulesState.emailPageMeta = res.pageMeta;
            this.setModulesState();
        }
    }
    public setEmailDrawerVisible = (visible: boolean = false) => {
        this.modulesState.emailDrawerVisible = visible;
        this.setModulesState();
    }
    public setEmailSetVisible = (visible: boolean = false, data: any = {}) => {
        // this.modulesState.emailDrawerVisible = false; 
        this.modulesState.emailSetVisible = visible; 
        this.modulesState.emailData = {
            ...data,
            emailPwd: visible ? aec_secret.decrypt2(data.emailPwd) : ''
        };
        this.setModulesState();
    }

    public addEmail = async (values) => { 
        const response = await collection.emailSave(this, values);
        return response;
    }
    public updateEmail = async (values) => { 
        const response = await collection.emailUpdate(this, values);
        return response;
    }
    public deleteEmail = async (values) => {
        const response = await collection.emailDelete(this, { id: values.id });
        return response;
    } 
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/Modules.Action.ts